import { ref } from 'vue';
import { smsSendSenaoMembership } from '@/api/member-registration';
import { createFormDataFromOrderInfo } from '@/helpers/handle-fetch-register';
import { registerCodeEnum } from '@/constant/payment-info';
import store from '@/store/index';

export function useVerifyOTP() {
  const isDisabledCancelOTPBtn = ref(true); // 進 Step2 Modal 後，倒數計時結束前，取消按鈕不可按
  const isShowCountdownBlock = ref(true);
  const isDisabledReVerifyOTPBtn = ref(false); // 重發驗證碼鈕

  /**
   * 倒數計時 Logics
   */
  const countdownSecond = ref(300);
  const secondsRemaining = ref(countdownSecond.value);

  /**
   * 設定特殊情境: 倒數計時結束後的 Layout
   */
  const setCountdownEndLayout = () => {
    // 倒數結束時，check 是否有被紀錄輸入錯誤已達上限: isVerifyOTPLimit
    const { isVerifyOTPLimit } = store.state.RegisterSenaoMembership;
    if (isVerifyOTPLimit) {
      store.commit('RegisterSenaoMembership/setIsDisabledVerifyOTPBtn', false); // enabled 下一步鈕
      store.commit('RegisterSenaoMembership/setIsVerifyOTPLimit', false); // 還原
    }
  };

  /**
   * 設定倒數計時中及結束的 Layout，包含一進 step2 畫面及按下重發驗證碼鈕後
   * 控制項目為倒數計時中的區塊、取消按鈕、重發驗證碼鈕
   */
  const setCountdownLayout = (isCountingDownValue) => {
    isDisabledCancelOTPBtn.value = isCountingDownValue;
    isShowCountdownBlock.value = isCountingDownValue;
    isDisabledReVerifyOTPBtn.value = isCountingDownValue;
    if (isCountingDownValue === false) {
      setCountdownEndLayout();
    }
  };

  const countdownTick = () => {
    if (secondsRemaining.value > 0) {
      setTimeout(() => {
        secondsRemaining.value -= 1;
        countdownTick();
      }, 1000);
    } else {
      secondsRemaining.value = countdownSecond.value;
      setCountdownLayout(false); // set 倒數計時結束的 Layout
    }
  };

  const startCountdown = () => {
    setCountdownLayout(true); // set 倒數計時中的 Layout
    countdownTick();
  };

  const processReVerifyOTPResponse = (res) => {
    const { code, description } = res.data;
    const { successCode, exceededTimesCode, failCode } = registerCodeEnum;

    const handleResponseByCode = {
      [successCode]: () => {
        const { validateErrorMsg } = store.state.RegisterSenaoMembership;
        if (validateErrorMsg.length) {
          store.commit('RegisterSenaoMembership/setValidateErrorMsg', ''); // 清空錯誤訊息
        }
        alert('發送成功');
        startCountdown();
      },
      [exceededTimesCode]: () => {
        store.commit('RegisterSenaoMembership/setValidateErrorMsg', description);
        isDisabledCancelOTPBtn.value = false; // enabled 取消鈕讓 user 自行決定是否繼續結帳
        store.commit('RegisterSenaoMembership/setIsDisabledVerifyOTPBtn', true); // disabled 下一步鈕
        isDisabledReVerifyOTPBtn.value = true; // disabled 重發驗證碼鈕
        // 這裡沒有主動關掉 Modal 的原因是讓使用者知道錯誤訊息，目前的狀態已超出當日發送次數，需明日再試。
      },
    };
    if (code === exceededTimesCode || code === failCode) {
      return handleResponseByCode[exceededTimesCode]();
    }
    return handleResponseByCode[successCode]();
  };

  const fetchReVerifyOTP = () =>
    smsSendSenaoMembership(createFormDataFromOrderInfo(true)).then((res) => processReVerifyOTPResponse(res));

  return {
    isDisabledCancelOTPBtn,
    isShowCountdownBlock,
    isDisabledReVerifyOTPBtn,
    secondsRemaining,
    startCountdown,
    fetchReVerifyOTP,
  };
}
